import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { labFieldKeys } from '../constants';
import { useApiToast } from '@hooks/useApiToast';

export const useCreateLabFieldValue = () => {
  const queryClient = useQueryClient();
  const { showError } = useApiToast();

  return useMutation<string, Error, string>({
    mutationFn: async (value: string) => {
      const response = await bffApiClient.post<string>(
        '/api/lab-field/values',
        {
          value
        }
      );
      return response.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labFieldKeys.all });
    },

    onError: error => {
      showError('labField.createError', error, 'settings');
    }
  });
};
